<template>
  <v-main class="pa-2 report_detail" fluid>

    <h1>Daily Report</h1>

    <section>
      <v-row>
        <v-col cols="12" md="4" v-if="checkGate('sales-access')">
          <v-subheader>Notes</v-subheader>
          <p v-if="currentDateSales">{{ currentDateSales.report }}</p>

          <v-subheader>From day before</v-subheader>
          <p v-if="prevDateSales">{{ prevDateSales.report }}</p>



        </v-col>

        <v-col cols="12" md="8">
          <v-subheader>Day Status</v-subheader>

          <v-data-table class="no-footer-table" :headers="countsHeaders" :items="dayTotals">
          </v-data-table>
        </v-col>
      </v-row>
    </section>

    <DailySales v-if="checkGate('sales-access')" @logSales="openDialog" @editSalesReport="edit" @bankTotalInSafe="bank" />

    <Staff />

    <AircraftLogs v-if="checkGate('aircrafts-log-mgmt')" />
    <PackingJobs v-if="checkGate('packing-jobs-mgmt')" />
    <DayPicker @reloadData="loadData" />

    <v-dialog v-if="checkGate('sales-access')" v-model="dialog" @keydown.esc="dialog = false" persistent
      max-width="600px">
      <v-form v-model="valid" @submit.prevent="save">
        <v-card>
          <v-card-text>

            <fieldset class="inline-form input-6">
              <legend>Cash : ${{ cashTotal }}</legend>

              <v-text-field ref="ones" label="$1" v-model="editedItem.ones" type="number"></v-text-field>
              <v-text-field ref="fives" label="$5" v-model="editedItem.fives" type="number"></v-text-field>
              <v-text-field ref="tens" label="$10" v-model="editedItem.tens" type="number"></v-text-field>
              <v-text-field ref="twenties" label="$20" v-model="editedItem.twenties" type="number"></v-text-field>
              <v-text-field ref="fifties" label="$50" v-model="editedItem.fifties" type="number"></v-text-field>
              <v-text-field ref="hundreds" label="$100" v-model="editedItem.hundreds" type="number"></v-text-field>

            </fieldset>

            <fieldset class="inline-form input-4">
              <v-text-field prefix="$" readonly type="number" label="Cash on Hand" v-model="onHand"></v-text-field>

              <v-text-field prefix="$" readonly type="number" label="Cash Discrepancy"
                v-model="cashDiscrepancy"></v-text-field>
              <v-text-field prefix="$" type="number" label="Cash Deposited" v-model="editedItem.deposited"></v-text-field>

              <v-text-field readonly prefix="$" type="number" label="Tomorrow Start" v-model="tomoStart"></v-text-field>


            </fieldset>

            <v-text-field label="Reason for Discrepancy" v-model="editedItem.cashNotes"></v-text-field>

            <fieldset class="inline-form input-3">

              <legend>Credit Card</legend>

              <v-text-field v-if="calculatedDailySales" readonly prefix="$" type="number" label="Calculated"
                v-model="calculatedDailySales.ccSales"></v-text-field>

              <v-text-field prefix="$" type="number" label="CC Terminal" v-model="editedItem.ccTerminal"></v-text-field>
              <v-text-field prefix="$" readonly type="number" label="CC Discrepancy"
                v-model="ccDiscrepancy"></v-text-field>

            </fieldset>


            <v-text-field label="Reason for Discrepancy" v-model="editedItem.ccNotes"></v-text-field>

            <hr />

            <v-text-field label="Notes" v-model="editedItem.report"></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" type="submit" :disabled="!valid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-main>
</template>
<script>
import { mapState } from 'vuex'
import AircraftLogs from '../components/AircraftLogs.vue'
import DailySales from '../components/DailySales.vue'
import DayPicker from '../components/DayPicker.vue'
import PackingJobs from '../components/PackingJobs.vue'
import Staff from '../components/Staff'



export default {

  components: { AircraftLogs, DailySales, DayPicker, PackingJobs, Staff },

  data() {

    return {

      countsHeaders: [
        { text: "", align: 'left', value: "name", sortable: false },
        { text: "Complete", align: 'left', value: "Complete", sortable: false },
        { text: "Incomplete", align: 'left', value: "Incomplete", sortable: false },
        { text: "Cancelled", align: 'left', value: "Cancelled", sortable: false },
        {
          text: "Taken Off and Cancelled", align: 'left', value: "TakenOffandCancelled", sortable: false
        },
        { text: "Total", align: 'left', value: "Total", sortable: false },
      ],

      viewingToday: true,

      dialog: false,
      editedIndex: -1,
      valid: true,

      editedItem: {
        ones: 0,
        fives: 0,
        tens: 0,
        twenties: 0,
        fifties: 0,
        hundreds: 0,
        deposited: 0,
        ccTerminal: 0,
        ccDiscrepancy: 0,
        cashDiscrepancy: 0,
        cashNotes: "",
        ccNotes: "",
        report: "",
        tomoStart: 0,
        client_id: this.$store.state.uuid,
        banked: 0
      },

      req: [
        v => !!v || 'Required',
      ],

    }
  },

  mounted() {

    //if (this.checkGate('sales-access'))
    this.$store.dispatch('fetchSalesReportbyDate', 'today')

    if (this.checkGate('aircrafts-log-mgmt'))
      this.$store.dispatch('fetchPlainReportbyDate', 'today')

  },


  computed: {

    ...mapState(['dailysales']),


    dayTotals() {

      return [this.dailysales.totalJumps, this.dailysales.totalLoads]
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Log Sales' : 'Edit Sales'
    },

    onHandItems() {
      return this.$store.getters.onHandItems
    },


    onHand() {

      return (this.editedItem.ones * 1) + (this.editedItem.fives * 5) + (this.editedItem.tens * 10) + (this.editedItem.twenties * 20) + (this.editedItem.fifties * 50) + (this.editedItem.hundreds * 100) || 0
    },

    dailySalesReport() {
      return this.$store.getters.dailySalesReport

    },
    calculatedDailySales() {
      return this.$store.getters.calculatedDailySales
    },

    currentDateSales() {
      return this.dailySalesReport ? this.dailySalesReport.currentDate : null
    },

    prevDateSales() {
      return this.dailySalesReport ? this.dailySalesReport.prevDate : null
    },


    ccDiscrepancy() {

      const ccSales = this.calculatedDailySales ? this.calculatedDailySales.ccSales : 0,

        ccDiscrepancy = this.editedItem.ccTerminal != 0 ? this.editedItem.ccTerminal - ccSales : 0

      this.editedItem.ccDiscrepancy = ccDiscrepancy

      return ccDiscrepancy

    },



    cashTotal() {


      const cashSales = this.calculatedDailySales ? parseFloat(this.calculatedDailySales.cashSales) : 0,

        cashStart = this.prevDateSales ? this.prevDateSales.cashTomoStart : 0


      return cashSales + cashStart || 0

    },


    cashDiscrepancy() {


      //const cashDiscrepancy = this.onHand != 0 ? this.cashTotal - this.onHand : 0

      const cashDiscrepancy = this.cashTotal - this.onHand

      this.editedItem.cashDiscrepancy = cashDiscrepancy
      return cashDiscrepancy


    },


    tomoStart() {


      var tomoStart = 0,

        cashSales = this.calculatedDailySales ? parseFloat(this.calculatedDailySales.cashSales) : 0,
        cashStart = this.dailySalesReport && this.dailySalesReport.length ? parseFloat(this.dailySalesReport.cashStart) : 0,
        cashTotal = cashSales + cashStart

      tomoStart = this.onHand - this.editedItem.deposited

      this.editedItem.cashTomoStart = tomoStart

      return tomoStart

    },


  },

  methods: {

    openDialog() {
      this.dialog = true
    },


    edit(item) {

      this.editedIndex = 0
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    bank(item) {

      this.editedIndex = 0
      this.editedItem = Object.assign({}, item)

      axios.put('/api/sales/bank/' + this.editedItem.id, this.editedItem)
        .then(response => {

          this.$store.dispatch('fetchSalesReportbyDate', this.$store.state.currentDate)

          this.close()

        }).catch(err => {
          console.log(err)
        })

    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1

      })
    },


    save() {

      this.editedItem.ccTerminal = this.editedItem.ccTerminal == "" ? 0 : this.editedItem.ccTerminal
      this.editedItem.deposited = this.editedItem.deposited == "" ? 0 : this.editedItem.deposited
      this.editedItem.cashOnHand = this.onHand

      this.editedItem.cashStart = this.prevDateSales ? this.prevDateSales.cashTomoStart : 0
      this.editedItem.saleDate = this.$store.state.currentDate


      if (this.editedIndex > -1) {


        axios.put('/api/sales/' + this.editedItem.id, this.editedItem)
          .then(response => {

            this.$store.dispatch('fetchSalesReportbyDate', this.$store.state.currentDate)
            this.close()

          })
          .catch(err => {
            console.log(err)
          })


      } else {


        axios.post('/api/sales', this.editedItem)
          .then(response => {

            this.$store.dispatch('fetchSalesReportbyDate', this.$store.state.currentDate)
            this.close()

          })
          .catch(err => {
            console.log(err)
          })

      }

    },


    loadData(day) {


      const date = new Date(day + "T00:00:00")

      this.viewingToday = date.isToday() ? true : false

      //if (this.checkGate('sales-access'))
      this.$store.dispatch('fetchSalesReportbyDate', day)

      if (this.checkGate('aircrafts-log-mgmt'))
        this.$store.dispatch('fetchPlainReportbyDate', day)

      if (this.checkGate('packing-jobs-mgmt'))
        this.$store.dispatch('fetchPacksReportbyDate', day)

      this.$store.dispatch('fetchWagesReportbyDate', day)
    },



  }
}
</script>